import { Box, Stack } from "@mui/system";
import BudgetSearchItemsCard from "./BudgetSearchItemsCard";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Typography } from "@mui/material";
import { setFilteredRecordsForBudgetMobile } from "../../../../../../../../../features/businessLeaderDashboardSlice";

const getColor = (value: number): "success" | "warning" | "error" => {
  if (value >= 95) return "error";
  if (value >= 90) return "warning";
  return "success";
};

const BudgetSearchItems = () => {
  const dispatch = useDispatch();
  const [sortedData, setSortedData] = useState<any[]>([]);
  const { budgetDataListMobile, sortForBudget, selectedBrandForBudget } =
    useSelector((state: any) => state.businessLeaderDashBoard);

  const filteredRows = useMemo(() => {
    return (sortedData || []).filter((row: any) => {
      const searchMatch = selectedBrandForBudget
        ? row.brand
            ?.toLowerCase()
            .trim()
            .includes(selectedBrandForBudget?.toLowerCase().trim())
        : true;

      return searchMatch;
    });
  }, [sortedData, selectedBrandForBudget]);

  const getSortedData = useCallback(
    (arrayToSort: any[]) => {
      if (!sortForBudget.keytoSort || !sortForBudget.direction) {
        return arrayToSort;
      }

      return arrayToSort.slice().sort((a, b) => {
        const keytoSort = sortForBudget.keytoSort;

        if (keytoSort === undefined) return 0;

        let aValue = a[keytoSort];
        let bValue = b[keytoSort];

        if (aValue === undefined) return 1;
        if (bValue === undefined) return -1;
        if (aValue === "") return 1;
        if (bValue === "") return -1;

        if (typeof aValue === "string" && typeof bValue === "string") {
          return sortForBudget.direction === "asc"
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        } else if (typeof aValue === "number" && typeof bValue === "number") {
          return sortForBudget.direction === "asc"
            ? aValue - bValue
            : bValue - aValue;
        } else {
          return sortForBudget.direction === "asc"
            ? String(aValue).localeCompare(String(bValue))
            : String(bValue).localeCompare(String(aValue));
        }
      });
    },
    [sortForBudget],
  );

  useEffect(() => {
    if (!budgetDataListMobile) return;
    const modifiedBudgetDataListMobile =
      budgetDataListMobile.map((item: any) => {
        const perc_Qftd_budget_use = Math.round(
          (item?.perc_Qftd_budget_use || 0) * 100,
        );

        const perc_of_RR_qftd_budget_use = Math.round(
          (item?.perc_of_RR_qftd_budget_use || 0) * 100,
        );

        return {
          brand: item?.brand || "",
          brand_id: item?.brand_id || "",
          qftd: Math.round(item?.qftd || 0),
          qftd_budget: Math.round(item?.qftd_budget || 0),
          perc_Qftd_budget_use: `${perc_Qftd_budget_use}%`,
          budget_color: getColor(perc_Qftd_budget_use),
          Qftd_RR: Math.round(item?.Qftd_RR || 0),
          perc_of_RR_qftd_budget_use: `${perc_of_RR_qftd_budget_use}%`,
          rr_color: getColor(perc_of_RR_qftd_budget_use),
        };
      }) || [];

    const sortedData = getSortedData(modifiedBudgetDataListMobile);
    setSortedData(sortedData);
  }, [budgetDataListMobile, getSortedData]);

  // filterd data set in redux for other components
  useEffect(() => {
    if (!filteredRows || filteredRows.length === 0) return;
    dispatch(setFilteredRecordsForBudgetMobile(filteredRows || []));
    // eslint-disable-next-line
  }, [filteredRows]);

  return (
    <>
        {filteredRows?.length > 0 ? (
          filteredRows?.map((item: any) => (
            <>
              <Stack spacing={2} key={item?.brand_id}>
                <BudgetSearchItemsCard
                  key={item?.brand_id}
                  title={item?.brand}
                  brandId={item?.brand_id}
                  value={item?.qftd}
                  budget={item?.qftd_budget}
                  budgetPercentage={item?.perc_Qftd_budget_use}
                  budgetColor={item?.budget_color}
                  rr={item?.Qftd_RR}
                  rrPercentage={item?.perc_of_RR_qftd_budget_use}
                  rrColor={item?.rr_color}
                />
                {/* <BudgetSearchItemsCard
                    title="Bettom Sport UK"
                    brandId="2319"
                    value="210"
                    budget="200"
                    budgetPercentage="105%"
                    budgetColor="error"
                    rr="217"
                    rrPercentage="109%"
                    rrColor="error"
                  />
                  <BudgetSearchItemsCard
                    title="Virgin Bet Sport UK"
                    brandId="801"
                    value="175"
                    budget="300"
                    budgetPercentage="89%"
                    budgetColor="warning"
                    rr="167"
                    rrPercentage="96%"
                    rrColor="success"
                  /> */}
              </Stack>
            </>
          ))
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
                color: "text.secondary",
              }}
            >
              <Typography variant="body1" sx={{ mt: 1 }}>
                No data to display.
              </Typography>
            </Box>
          </>
        )}
    </>
  );
};

export default BudgetSearchItems;
